//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import { useTheme } from 'styled-components';

import DropdownSelect from '@components/molecules/dropdown-select/DropdownSelect';
import ClientId from '@models/ClientId';
import { UiaProductTrackingIds } from '@uia/products/constants/UiaProductConstants';
import { CatalogClient } from '@uia/products/hooks/useProductCatalogClientsQuery';

export interface UiaCatalogClientSelectorProps {
  catalogClientId: ClientId | undefined;
  catalogClients: CatalogClient[];
  setCatalogClientId: (catalogClientId: ClientId) => void;
}

export const UiaCatalogClientSelector = ({
  catalogClientId,
  catalogClients,
  setCatalogClientId,
}: UiaCatalogClientSelectorProps) => {
  const theme = useTheme();

  return (
    <DropdownSelect
      dropdownContentZIndex={theme.zindex.popover} // to ensure the dropdown appears above the UIA modal
      handleSelect={setCatalogClientId}
      items={catalogClients.map((catalogClient) => {
        return {
          value: catalogClient.clientId,
          label: catalogClient.clientName,
        };
      })}
      label='Select a product catalog'
      trackingId={UiaProductTrackingIds.CATALOG_CLIENT_DROPDOWN}
      value={catalogClientId}
    />
  );
};
